import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Auth/AuthContext";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { authState } = useAuth();
  const { isAuthenticated, roles, user } = authState;
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  if (roles !== "Admin" && user?.isApprovedByAdmin === false && location.pathname !== "/home") {
    return <Navigate to="/home" replace />;
  }

  if (requiredRole && roles !== requiredRole) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default ProtectedRoute;
